import { PaginationResponse } from "models/pagination-response";
import { IOfficialDiaryPagedRequest } from "models/request/official-diary-paged-request";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";
import { ICategoriesPublicationListResponnse } from "models/response/categories-publication-list-responnse";
import { IOfficialDiaryPagedResponse } from "models/response/official-diary-paged-response";
import { IPublicationPagedResponse } from "models/response/publication-paged-response";
import { IPublisingVehicleListReponse } from "models/response/publishing-vehicle-list-repsonse";

export type PublicationsState = {
    officialDailyResponse: PaginationResponse<IOfficialDiaryPagedResponse>;
    publicationsResponse: PaginationResponse<IPublicationPagedResponse>;
    officialDailyRequest: IOfficialDiaryPagedRequest;
    publicationRequest: IPublicationPagedReqeust;
    categories: ICategoriesPublicationListResponnse[];
    publisingVehicles: IPublisingVehicleListReponse[];
    loading: boolean
};

export enum ACTION_TYPES {
    setOfficialDailyResponse = 'setOfficialDailyResponse',
    setPublisingVehicles = 'setPublisingVehicles',
    setOfficialDailyRequest = 'setOfficialDailyRequest',
    setPublicationsResponse = 'setPublicationsResponse',
    setPublicationRequest = 'setPublicationRequest',
    setCategories = 'setCategories',
    setLoading = "setLoading",
}

export const PublicationsReducer = (state: PublicationsState, action: any): PublicationsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPublicationRequest:
            return {
                ...state,
                publicationRequest: payload,
            };
        case ACTION_TYPES.setPublisingVehicles:
            return {
                ...state,
                publisingVehicles: payload,
            };
        case ACTION_TYPES.setPublicationsResponse:
            return {
                ...state,
                publicationsResponse: payload,
            };
        case ACTION_TYPES.setCategories:
            return {
                ...state,
                categories: payload,
            };
        case ACTION_TYPES.setOfficialDailyResponse:
            return {
                ...state,
                officialDailyResponse: payload,
            };


        case ACTION_TYPES.setOfficialDailyRequest:
            return {
                ...state,
                officialDailyRequest: payload,
            };

        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };

        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}